/* CustomControl.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _8 = "._1wyb1j6v{font-size:1rem}";
const _7 = "._2rkojs4s{border-radius:var(--ds-border-radius,.25rem)}";
const _6 = "._19it13y5{border:solid 1px var(--ds-border)}";
const _5 = "._18s8xjmg{margin:var(--ds-space-200)}";
import { components } from '@atlaskit/select';
import VisuallyHidden from '@atlaskit/visually-hidden';
import React from 'react';
import { charlieTextFontFamily } from '../../../FontFamily';
const _4 = "._n7zl13y5{border-bottom:solid 1px var(--ds-border)}";
const _3 = "._1yt4h461{padding:var(--ds-space-050)}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._ect41sdi{font-family:Charlie Text,-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
export const SearchBarControl = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_ect41sdi _1e0c1txw _1yt4h461 _n7zl13y5", __cmplp.className])
  })));
});

/**
 * Replaces the default Control component in React Select.
 * When the select is searchable, it shows a search bar.
 * Otherwise, it renders a search box but visually hides it. This is to retain keyboard accessibilty features
 * (focus, key navigation) in the select dropdown.
 */
if (process.env.NODE_ENV !== 'production') {
  SearchBarControl.displayName = 'SearchBarControl';
}
export const CustomControl = props => {
  return props.selectProps.isSearchable ? /*#__PURE__*/React.createElement(SearchBarControl, _extends({
    ref: props.innerRef
  }, props.innerProps), props.children) : /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement(components.Control, props));
};
export const SearchBarControlMobile = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _5, _6, _7, _8]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_ect41sdi _1e0c1txw _18s8xjmg _19it13y5 _2rkojs4s _1wyb1j6v", __cmplp.className])
  })));
});

/**
 * Replaces the default Control component in React Select.
 * When the select is searchable, it shows a search bar.
 * Otherwise, it renders a search box but visually hides it. This is to retain keyboard accessibilty features
 * (focus, key navigation) in the select dropdown.
 */
if (process.env.NODE_ENV !== 'production') {
  SearchBarControlMobile.displayName = 'SearchBarControlMobile';
}
export const CustomControlMobile = props => {
  return props.selectProps.isSearchable ? /*#__PURE__*/React.createElement(SearchBarControlMobile, _extends({
    ref: props.innerRef
  }, props.innerProps), props.children) : /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement(components.Control, props));
};